import { useTranslation } from "react-i18next";
import { useFetchDataRecently } from "~/features/RecentlyViewedProducts/useFetchDataRecently";
import { PurchasePlaceProvider } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import { type ProductData } from "~/domains/product/types/ProductData";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import {
  ProductRecommendationSection,
  ProductRecommendationTitle,
  ProductRecoType,
} from "~/features/saleRecommendations/components/ProductRecommendationSection";

export function RecentlyViewedProducts({ variant = "default" }: { variant?: "default" | "pdp" }) {
  const { t } = useTranslation();
  const recently = useFetchDataRecently(variant === "default");

  // As per SCHAEFF-33361, Max 12 products
  const data = recently?.data?.slice(0, 12) ?? [];
  const haveRecently = (data && data.length > 0) ?? false;
  const loading = recently.state === "loading";

  if (!loading && !haveRecently) {
    return null;
  }

  const getTrackingAttributes = (product: ProductData, productDescriptor: ProductDescriptor, isPMA: boolean) => {
    const linkProps = {
      "tracking-aux-rmp-name": product.designation,
      "tracking-aux-rmp-id": product.sapMaterialNumber,
      target: "_blank",
    };
    const buttonProps = {
      [`tracking-aux-rmp-request-quote`]: isPMA ? "true" : "false",
      [`tracking-aux-rmp-add-to-cart`]: !isPMA ? "true" : "false",
      reco_type: "rmp",
    };
    const wishListBtnProps = {
      [`tracking-aux-rmp-wishlist`]: "true",
    };
    return { linkProps, buttonProps, wishListBtnProps };
  };

  return (
    <>
      <ProductRecommendationSection
        title={<ProductRecommendationTitle>{t("recentlyViewProducts.title")}</ProductRecommendationTitle>}
        loading={loading}
        loadingLabel={t("feature.recentlyViewedProducts.loadingSection")}
        products={data.map((item) => item.code)}
        variant={ProductRecoType.recentlyViewed}
        getTrackingAttributes={getTrackingAttributes}
      />
    </>
  );
}

export function createRecentlyViewedProductsComponent() {
  return (
    <PurchasePlaceProvider value={"HOME"}>
      <RecentlyViewedProducts />
    </PurchasePlaceProvider>
  );
}
